module.exports = __webpack_public_path__ + "static/bench-li-ym-279a89d1eccbb5f59087a8d7ccc774ef.jpg";